import { apiClient } from './api';
import { ApiResponse } from '../types';

export interface CalibrationPointInput {
  real: number; // referenční hodnota (pufr) — co MÁ čidlo ukazovat
  measured: number; // co čidlo skutečně ukazuje (nekalibrovaná / základní hodnota)
}

export interface CalibrationInput {
  sensorId: string; // textové ID čidla (např. "ph-esp32rootifyF8AAE8")
  type: 'ph' | 'ec'; // typ čidla (pro UI/toast)
  mode?: 'two_point' | 'ec_single_point'; // default: two_point pro pH, ec_single_point jako volba pro EC
  point1: CalibrationPointInput;
  point2?: CalibrationPointInput; // nepovinný pro ec_single_point
  qcPassed?: boolean; // výsledek kontrolního měření; false → backend kalibraci nepoužije
}

// Odpovídá backend CalibrationSession (domain/models/calibration.ts)
export interface Calibration {
  id: number;
  sensorId: string;
  type: string; // 'two_point' | 'single_point'
  points: { expected: number; actual: number }[];
  offset: number;
  multiplier: number;
  status: 'active' | 'archived';
  createdAt: string;
  createdBy?: string;
}

export const calibrationService = {
  // Historie kalibrací pro konkrétní čidlo
  getCalibrations: async (sensorId: string): Promise<ApiResponse<Calibration[]>> => {
    return apiClient.get(`/calibrations/${sensorId}/history`);
  },

  // Vytvoření nové kalibrace — transformace na backend DTO
  createCalibration: async (data: CalibrationInput): Promise<ApiResponse<Calibration>> => {
    const isEcSingle = data.mode === 'ec_single_point';
    const payload = {
      sensorId: data.sensorId,
      type: isEcSingle ? 'ec_single_point' : 'two_point',
      points: isEcSingle
        ? [{ expected: data.point1.real, actual: data.point1.measured }]
        : [
            { expected: data.point1.real, actual: data.point1.measured },
            { expected: data.point2!.real, actual: data.point2!.measured },
          ],
      ...(data.qcPassed !== undefined ? { qcPassed: data.qcPassed } : {}),
    };
    return apiClient.post('/calibrations', payload);
  },

  // Smazání kalibrace
  deleteCalibration: async (calibrationId: number): Promise<ApiResponse<void>> => {
    return apiClient.delete(`/calibrations/${calibrationId}`);
  },

  // Všechny kalibrace (přehled)
  getAllCalibrations: async (): Promise<ApiResponse<Calibration[]>> => {
    return apiClient.get('/calibrations');
  },
};
